export default function ContactSection() {
  return (
    <section id="contact" className="py-24 bg-white">
      <div className="max-w-7xl mx-auto px-6 lg:px-10">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-start">
          {/* Left: info */}
          <div>
            <p className="text-xs tracking-widest text-orange-600 uppercase mb-3">Get in touch</p>
            <h2 className="text-4xl md:text-5xl font-display font-light text-gray-900 tracking-tight mb-6">
              Ready to Protect<br />Your Building?
            </h2>
            <p className="text-gray-500 text-sm leading-relaxed mb-10 max-w-sm">
              Whether you need a new flat roof, emergency repair, or an engineer-backed inspection —
              we're ready to help anywhere in New Jersey or Pennsylvania. Call or fill out the estimate form above.
            </p>

            {/* Emergency call-out */}
            <div className="flex items-center gap-4 p-5 bg-orange-700 text-white mb-8">
              <div className="w-10 h-10 flex items-center justify-center flex-shrink-0">
                <i className="ri-alarm-warning-line text-xl" />
              </div>
              <div>
                <p className="text-xs text-gray-300 mb-0.5">24-Hour Emergency Line</p>
                <a href="tel:8566776191" className="text-xl font-display font-semibold hover:underline cursor-pointer whitespace-nowrap">
                  (856) 677-6191
                </a>
              </div>
            </div>

            <div className="flex flex-col gap-6">
              {[
                { icon: 'ri-map-pin-2-line', label: 'Service Area', value: 'All of New Jersey & Pennsylvania' },
                { icon: 'ri-phone-line', label: 'Phone', value: '(856) 677-6191' },
                { icon: 'ri-mail-line', label: 'Email', value: 'info@gardenstaterooofing.com' },
                { icon: 'ri-time-line', label: 'Office Hours', value: 'Mon–Fri: 7am – 6pm | Emergency: 24/7' },
              ].map((item) => (
                <div key={item.label} className="flex items-start gap-4">
                  <div className="w-9 h-9 flex items-center justify-center border border-gray-200 flex-shrink-0 mt-0.5">
                    <i className={`${item.icon} text-orange-600 text-base`} />
                  </div>
                  <div>
                    <p className="text-xs text-gray-400 mb-0.5">{item.label}</p>
                    <p className="text-sm text-gray-900">{item.value}</p>
                  </div>
                </div>
              ))}
            </div>

            {/* Certification row */}
            <div className="mt-10 pt-8 border-t border-gray-100">
              <p className="text-xs text-gray-400 uppercase tracking-widest mb-4">Certified With</p>
              <div className="flex flex-wrap gap-2">
                {['GAF', 'Tamko', 'Duralast', 'Mulehide', 'Owens Corning'].map((b) => (
                  <span key={b} className="px-3 py-1.5 border border-gray-200 text-xs text-gray-600">{b}</span>
                ))}
              </div>
            </div>
          </div>

          {/* Right: Map of NJ */}
          <div className="w-full h-[500px] bg-gray-100 overflow-hidden">
            <iframe
              src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d1549628.0!2d-74.95!3d39.8!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x89c0fb959e00409f%3A0x2d2f4f8e5c4a3b12!2sNew%20Jersey%2C%20USA!5e0!3m2!1sen!2sus!4v1234567890"
              width="100%"
              height="100%"
              style={{ border: 0 }}
              allowFullScreen
              loading="lazy"
              referrerPolicy="no-referrer-when-downgrade"
              title="Garden State Roofing — Serving All of New Jersey"
            />
          </div>
        </div>
      </div>
    </section>
  );
}
